<h2>Forgot Password</h2>
<h4 class="success-text" *ngIf="isMailSent">
  Please check your email for the password reset mail.
</h4>
<form  autocomplete="off" *ngIf="!isMailSent" (ngSubmit)="submitForgotPasswordDetails()" #loginForm="ngForm">
<div  class="form-group">
  <div class="form-check-label success-text highlight-text">
    Please enter your email below. The forgot password link will be sent to this email address.
  </div>
</div>
<div class="form-group">
  <label for="username">User name</label>
  <input type="text" class="form-control login-input"
  id="forgot-password-username" required [(ngModel)]="forgotPasswordDetails.username" name="username"
    #username="ngModel">
    <div [hidden]="username.valid || username.pristine" class="error-text">
      Username is required.
  </div>
</div>
<button type="submit" id="forgot-password-send-email" class="btn btn-outline-success btn-block"
[attr.disabled]="!loginForm.form.valid  ? true : null">Send Email</button>
<div class="mt-1 login-page-link text-right">
  <a class="forgotPass_1" (click)="redirectToMainLogin()">Redirect to Login Page</a>
</div>
<div class="pt-4">
  <a class="font-small cp-hyperlink" routerLink='/terms'>Terms And Conditions</a>
</div>
<div class="pt-2">
  <a class="font-small cp-hyperlink" routerLink='/privacy-policy'>Privacy Policy</a>
</div>
</form>